import * as React from 'react';
import {View} from 'react-native';

import ListItem from '/component/base/ListItem';
import {LoadingBox} from '/component/base/LoadingBox';
import Text from '/component/base/Text';
import Gutter from '/component/layout/Gutter';
import {CoachInfoCard} from '/constant/TestIDs';
import {useTranslation} from '/provider/TranslationProvider';

import {styles} from './Loading.style';

export const Loading = () => {
  const {tt} = useTranslation('reportCardContent.earnedAccelerator');
  return (
    <View style={styles.base}>
      <View style={styles.header}>
        <Gutter>
          <Text variant="heading" testID={CoachInfoCard.earnedABTitle}>
            {tt('title', 'Earned Coach Accelerator Bonus')}
          </Text>
        </Gutter>
      </View>
      <Gutter>
        <ListItem
          style={{base: styles.listItem}}
          readonly={true}
          label={<LoadingBox style={styles.loadingBoxEarnedOn} />}
          suffix={<LoadingBox style={styles.loadingBoxEarnedOn} />}
        />
      </Gutter>
    </View>
  );
};
